export default {
  SET_MOMENTS(state, payload) {
    state.moments = payload;
  },
  SET_MOMENTS_CONTACT(state, payload) {
    state.contact = payload;
  }
};
